export type Block =
  | { type: "h2"; text: string }
  | { type: "h3"; text: string }
  | { type: "p"; text: string }
  | { type: "quote"; text: string }
  | { type: "list"; items: string[] };

export interface Category {
  slug: string;
  name: string;
  icon: string;
  desc: string;
  count: number;
}

export interface Article {
  id: number;
  title: string;
  categorySlug: string;
  excerpt: string;
  cover: string;
  author: string;
  date: string;
  views: number;
  hot: boolean;
  tags: string[];
  content: Block[];
}

export const siteInfo = {
  name: "看料91",
  slogan: "点开进入浏览，翻看阅读查看一手现场",
  intro:
    "看料91聚合热门爆料与现场记录，把分散在各处的话题内容整理成清晰的分类与专题。想看什么直接点，不用绕路，页面内持续更新，方便你快速找到感兴趣的料。",
  email: "hello@kanliao91.example.com",
  workTime: "每日 09:00 - 23:00 持续更新",
  icp: "",
};

export const categories: Category[] = [
  { slug: "entertainment", name: "娱乐八卦", icon: "ri-mic-line", desc: "综艺幕后、演出直击与圈内动态的现场记录。", count: 26 },
  { slug: "film", name: "影视综艺", icon: "ri-movie-line", desc: "剧集口碑、片场路透与幕后花絮的整理阅读。", count: 21 },
  { slug: "society", name: "社会热点", icon: "ri-earth-line", desc: "城市变迁与公共话题的现场观察与梳理。", count: 18 },
  { slug: "lifestyle", name: "生活方式", icon: "ri-cup-line", desc: "咖啡、露营与社区生活的真实体验记录。", count: 24 },
  { slug: "tech", name: "科技数码", icon: "ri-cpu-line", desc: "智能家居与创作者工具的实用观察合集。", count: 15 },
  { slug: "fashion", name: "潮流时尚", icon: "ri-vip-diamond-line", desc: "穿搭趋势、展览打卡与审美风向的整理。", count: 19 },
];

export const articles: Article[] = [
  {
    id: 1,
    title: "人气综艺录制现场曝光：后台花絮比正片还有料",
    categorySlug: "film",
    excerpt: "观众在录制现场拍到嘉宾候场时的互动片段，节目组随后放出一批幕后花絮，讨论热度一路走高。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20television%20studio%20backstage%20corridor%20with%20soft%20amber%20lighting%2C%20empty%20director%20chairs%20and%20warm%20cream%20walls%2C%20minimal%20clean%20background%2C%20magazine%20style%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=600&seq=kl-art-01&orientation=landscape",
    author: "看料编辑部",
    date: "2026-09-12",
    views: 48213,
    hot: true,
    tags: ["综艺花絮", "录制现场", "幕后记录"],
    content: [
      { type: "p", text: "最近一段时间，一档话题度颇高的综艺节目进入集中录制期。多位观众在社交平台分享了自己在现场外围拍到的画面，其中候场区嘉宾之间轻松互动的小片段被反复转发，成为了讨论的起点。" },
      { type: "h2", text: "现场秩序井然，观众席反馈热烈" },
      { type: "p", text: "从公开的现场片段看，录制当天的观众席几乎座无虚席。节目组在入场环节做了较为细致的引导，观众按区域分批进场，整体秩序保持得不错。有观众提到，正片之外的互动环节反而是当天最惊喜的部分。" },
      { type: "quote", text: "真正让人记住的往往不是剪辑后的成片，而是那些没有脚本的临场反应。" },
      { type: "h2", text: "花絮释放后，讨论度再次上升" },
      { type: "p", text: "节目组随后在官方渠道放出了一批幕后花絮，包括道具准备、彩排走位和嘉宾化妆间的日常片段。相比正片的紧凑节奏，花絮的松弛感让不少观众觉得更真实，也让节目相关话题在榜单上停留了更长时间。" },
      { type: "list", items: ["候场互动片段成为转发热点", "花絮内容补齐了正片之外的语境", "观众更关注真实反应而非剧本"] },
      { type: "h3", text: "为什么花絮更容易被记住" },
      { type: "p", text: "有长期关注综艺的观众分析，花絮之所以更容易被记住，是因为它呈现了未经修饰的瞬间，节奏更慢、信息更碎，反而贴近日常聊天的状态，观看门槛更低。" },
      { type: "p", text: "目前节目仍在陆续录制中，后续是否会有更多现场内容释出，值得继续关注。" },
    ],
  },
  {
    id: 2,
    title: "城市夜经济观察：深夜市集的人流为什么翻了一倍",
    categorySlug: "society",
    excerpt: "走访多个夜间市集后发现，延长营业时间与主题化布展，是吸引人流回流的主要原因。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20night%20market%20street%20scene%20with%20soft%20amber%20string%20lights%2C%20small%20food%20stalls%20and%20gentle%20crowd%2C%20clean%20minimal%20composition%2C%20editorial%20photography%2C%20warm%20cream%20and%20orange%20tones%2C%20high%20detail&width=800&height=600&seq=kl-art-02&orientation=landscape",
    author: "看料编辑部",
    date: "2026-09-11",
    views: 31980,
    hot: true,
    tags: ["夜经济", "城市观察", "市集"],
    content: [
      { type: "p", text: "入秋之后，多个片区的夜间市集陆续调整了营业时间，部分摊位从傍晚一直经营到深夜。走访发现，工作日晚间的人流比上个月同期明显增加，热门摊位前甚至需要排队。" },
      { type: "h2", text: "主题化布展带来停留时间增长" },
      { type: "p", text: "与过去杂乱的摊位排布不同，现在的市集更强调主题分区，比如手作区、餐饮区和演出区相互错开。观众在逛的过程中有明确的动线，停留时间自然被拉长。" },
      { type: "h2", text: "摊主与消费者的双向反馈" },
      { type: "p", text: "多位摊主表示，夜间时段的客单价并不比白天低，反而因为氛围轻松，顾客更愿意多买一份小吃或一件手作。也有消费者提到，希望后续能增加更多休息区和照明细节。" },
      { type: "list", items: ["延长营业时间拉动了晚间客流", "主题分区提升了逛展体验", "照明与休息区仍是改进重点"] },
      { type: "quote", text: "夜市的魅力不在商品本身，而在于它给了城市一个放慢节奏的理由。" },
      { type: "p", text: "可以预期，随着气温进一步下降，如何保持夜间人流的稳定性，会成为运营方接下来需要面对的课题。" },
    ],
  },
  {
    id: 3,
    title: "秋冬穿搭趋势笔记：复古色调重新回到街头",
    categorySlug: "fashion",
    excerpt: "从街拍与品牌新品看，焦糖、橄榄绿与奶油白成为本季讨论度最高的配色方向。",
    cover:
      "https://readdy.ai/api/search-image?query=Folded%20autumn%20knitwear%20and%20wool%20coat%20flat%20lay%20with%20caramel%20and%20olive%20tones%20on%20warm%20cream%20background%2C%20minimal%20editorial%20still%20life%2C%20soft%20natural%20light%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=600&seq=kl-art-03&orientation=landscape",
    author: "看料编辑部",
    date: "2026-09-10",
    views: 27455,
    hot: false,
    tags: ["秋冬穿搭", "复古色调", "街拍"],
    content: [
      { type: "p", text: "进入九月，街头的穿衣风格开始明显转向。相比夏季的高饱和色彩，本季更多出现焦糖、橄榄绿和奶油白这类低饱和的复古色调，整体观感更稳重。" },
      { type: "h2", text: "三种配色方向的搭配思路" },
      { type: "p", text: "从近期的街拍素材看，焦糖色外套搭配奶油白内搭是最常见的组合；橄榄绿则更适合与深色牛仔搭配，整体层次感较强。整体规律是：主色不超过两种，其余留给面料本身的质感。" },
      { type: "list", items: ["焦糖 + 奶油白：温暖通勤感", "橄榄绿 + 深牛仔：克制中性风", "驼色 + 米灰：松弛日常感"] },
      { type: "h3", text: "被忽略的细节：比例与版型" },
      { type: "p", text: "比起颜色，版型往往更影响整体效果。短款外套搭配高腰下装能拉长比例，宽松外套则建议内搭收紧，避免上下同时膨胀。" },
      { type: "quote", text: "好的搭配不是堆叠单品，而是让每一件衣服都找到自己的位置。" },
    ],
  },
  {
    id: 4,
    title: "国产新剧口碑反转：开分不高却越看越上头",
    categorySlug: "film",
    excerpt: "剧集前期节奏被质疑拖沓，随着剧情推进，人物关系逐渐立住，评分出现明显回升。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20still%20of%20an%20empty%20vintage%20living%20room%20set%20with%20soft%20lamp%20light%2C%20muted%20amber%20and%20cream%20palette%2C%20editorial%20film%20aesthetic%2C%20minimal%20clean%20composition%2C%20high%20detail&width=800&height=600&seq=kl-art-04&orientation=landscape",
    author: "看料编辑部",
    date: "2026-09-09",
    views: 39877,
    hot: true,
    tags: ["国产剧", "口碑反转", "剧评"],
    content: [
      { type: "p", text: "一部近期上线的国产剧在开播初期评分并不理想，不少观众认为前几集节奏偏慢。但随着剧情推进，人物动机逐渐清晰，讨论风向出现了明显转变。" },
      { type: "h2", text: "前期铺垫为何容易被低估" },
      { type: "p", text: "该剧在前四集花了大量篇幅交代背景与人物关系，这在当下快节奏的观剧习惯里确实容易劝退。不过当这些铺垫在后半段被一一回收时，不少观众又回头补看前几集，评价随之改善。" },
      { type: "h2", text: "值得关注的表演与细节" },
      { type: "p", text: "除了剧本结构，几位配角的表演也被反复提及。一些看似随意的日常对话，实际承担了推动关系变化的作用，这种处理让剧情的可信度提升不少。" },
      { type: "list", items: ["前四集偏慢，后面回收伏笔", "配角表演成为加分项", "评分在剧情推进后明显回升"] },
      { type: "p", text: "这类口碑反转并不少见，也提醒观众不妨多给慢热剧集一点耐心。" },
    ],
  },
  {
    id: 5,
    title: "智能家居实用改造清单：收纳也能变得很科技",
    categorySlug: "tech",
    excerpt: "从感应灯带到智能标签，一些小成本的改造就能让日常收纳效率明显提升。",
    cover:
      "https://readdy.ai/api/search-image?query=Neatly%20organized%20modern%20home%20storage%20shelf%20with%20small%20smart%20devices%20and%20warm%20wood%20textures%2C%20soft%20amber%20lighting%2C%20minimal%20clean%20background%2C%20editorial%20photography%2C%20high%20detail%20composition&width=800&height=600&seq=kl-art-05&orientation=landscape",
    author: "看料编辑部",
    date: "2026-09-08",
    views: 18902,
    hot: false,
    tags: ["智能家居", "收纳", "数码好物"],
    content: [
      { type: "p", text: "提到智能家居，很多人第一反应是昂贵的整套系统。其实对多数家庭来说，从几个小件入手，就能明显改善日常收纳与取用的效率。" },
      { type: "h2", text: "从这三个小改造开始" },
      { type: "p", text: "第一是柜内感应灯带，开门即亮，找东西不再需要举着手机；第二是智能标签，用手机就能记录收纳内容；第三是鞋柜除湿模块，避免季节交替时的异味。" },
      { type: "list", items: ["柜内感应灯带：开门即亮", "智能标签：方便记录与查找", "除湿模块：改善柜内环境"] },
      { type: "h3", text: "别为了智能而智能" },
      { type: "p", text: "需要注意的是，工具的价值在于减少麻烦，而不是增加学习成本。选择操作简单、耗材易补的产品，才更可能长期用下去。" },
      { type: "quote", text: "好的科技改造，是让人几乎感觉不到它的存在。" },
    ],
  },
  {
    id: 6,
    title: "音乐节现场直击：万人合唱把气氛推到了顶点",
    categorySlug: "entertainment",
    excerpt: "连续两天的音乐节在傍晚迎来高潮，压轴曲目引发全场大合唱，现场照片持续刷屏。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20outdoor%20music%20festival%20stage%20at%20dusk%20with%20glowing%20amber%20lights%20and%20blurred%20crowd%2C%20minimal%20clean%20composition%2C%20editorial%20photography%2C%20cream%20and%20orange%20palette%2C%20high%20detail&width=800&height=600&seq=kl-art-06&orientation=landscape",
    author: "看料编辑部",
    date: "2026-09-07",
    views: 52130,
    hot: true,
    tags: ["音乐节", "现场直击", "演出记录"],
    content: [
      { type: "p", text: "为期两天的户外音乐节在周末落幕。傍晚灯光亮起后，现场气氛迅速升温，压轴曲目登场时，几乎所有人都举起了手机与荧光手环。" },
      { type: "h2", text: "现场体验的细节记忆" },
      { type: "p", text: "不少观众在事后分享，真正印象深刻的并非某一首歌，而是那些共同经历的瞬间：一起倒数、一起跟唱、一起等待下一段旋律。这种集体参与感很难被录音完整保留。" },
      { type: "quote", text: "音乐结束时，人散了，但那个瞬间会留很久。" },
      { type: "h2", text: "主办方的现场安排" },
      { type: "p", text: "从现场反馈看，场地分区、补给点与散场引导都做得比较到位。也有观众建议增加卫生间数量，并在散场后延长接驳车运营时间。" },
      { type: "list", items: ["压轴曲目引发全场合唱", "场地分区与引导较为顺畅", "散场交通仍是改进方向"] },
    ],
  },
  {
    id: 7,
    title: "咖啡文化走进社区：街角小店成了年轻人的新据点",
    categorySlug: "lifestyle",
    excerpt: "越来越多小体量咖啡店开在居民楼下，靠稳定的熟客和松弛的氛围维持经营。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20small%20neighborhood%20coffee%20shop%20corner%20with%20warm%20wooden%20counter%20and%20soft%20amber%20light%2C%20latte%20cup%20on%20table%2C%20minimal%20cream%20background%2C%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=kl-art-07&orientation=landscape",
    author: "看料编辑部",
    date: "2026-09-06",
    views: 23140,
    hot: false,
    tags: ["咖啡", "社区生活", "小店经济"],
    content: [
      { type: "p", text: "在不少居民区的一层，最近陆续出现了体量不大的咖啡店。它们大多只有十几个座位，装修简单，却常常坐满熟客。" },
      { type: "h2", text: "为什么是社区楼下" },
      { type: "p", text: "相比商圈，社区店的租金更低，客源也更稳定。店主普遍表示，稳定的回头客比短期爆单更重要，因此更愿意花时间记住每位常客的口味。" },
      { type: "h2", text: "松弛感才是核心竞争力" },
      { type: "p", text: "来这里的顾客，多半是下楼散步或在家办公时顺路坐一会儿。没有催促、没有排队压力，这种松弛感本身就是吸引人的理由。" },
      { type: "list", items: ["社区店租金压力更小", "熟客复购带来稳定收入", "氛围比流量更重要"] },
      { type: "p", text: "当然，社区店也需要面对客流天花板的问题，如何在有限的空间里保持品质，是长期的考验。" },
    ],
  },
  {
    id: 8,
    title: "短视频创作新动向：普通人出镜正在成为主流",
    categorySlug: "tech",
    excerpt: "手机拍摄与轻量剪辑工具的普及，让更多没有专业背景的人开始尝试出镜创作。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20modern%20desk%20setup%20with%20smartphone%20on%20ring%20light%20and%20small%20microphone%2C%20soft%20amber%20lighting%2C%20minimal%20cream%20background%2C%20editorial%20photography%2C%20high%20detail%20composition&width=800&height=600&seq=kl-art-08&orientation=landscape",
    author: "看料编辑部",
    date: "2026-09-05",
    views: 20760,
    hot: false,
    tags: ["短视频", "创作工具", "内容趋势"],
    content: [
      { type: "p", text: "过去，做视频常被看作需要专业设备的工作。但随着手机拍摄能力和轻量剪辑工具的成熟，越来越多的普通人开始尝试出镜，把日常生活记录下来。" },
      { type: "h2", text: "门槛降低带来的变化" },
      { type: "p", text: "现在一部手机加一个补光灯，就能完成基本拍摄；剪辑也可以在手机上完成。门槛降低后，内容题材变得更贴近生活，反而更容易引起共鸣。" },
      { type: "h2", text: "内容质量才是长期竞争力" },
      { type: "p", text: "工具只是起点。真正决定作品能否被记住的，仍是选题是否有价值、表达是否清晰。有创作者提到，与其追求设备升级，不如先想清楚要讲什么。" },
      { type: "list", items: ["手机即可完成基本拍摄与剪辑", "生活化题材更易产生共鸣", "选题与表达比设备更关键"] },
    ],
  },
  {
    id: 9,
    title: "老城区改造记录：烟火气与新生机如何并存",
    categorySlug: "society",
    excerpt: "在保留原有街巷肌理的前提下，部分老街区通过微改造重新聚集了人气。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20renovated%20old%20town%20alley%20with%20brick%20walls%2C%20hanging%20plants%20and%20soft%20afternoon%20light%2C%20minimal%20clean%20composition%2C%20editorial%20photography%2C%20warm%20cream%20and%20terracotta%20tones&width=800&height=600&seq=kl-art-09&orientation=landscape",
    author: "看料编辑部",
    date: "2026-09-04",
    views: 17640,
    hot: false,
    tags: ["老城区", "城市更新", "街巷"],
    content: [
      { type: "p", text: "老城区的改造一直是个难题：拆得太多会失去原有的生活气息，保留得太多又难以满足现代需求。近两年，一些街区尝试用微改造的方式寻找平衡。" },
      { type: "h2", text: "微改造改了什么" },
      { type: "p", text: "改造重点集中在管线梳理、路面铺装和公共座椅的增设上。原有建筑的外立面和街巷尺度基本保留，新增的部分多为可逆的小体量设施。" },
      { type: "h2", text: "居民与访客的不同视角" },
      { type: "p", text: "对居民而言，最直观的感受是环境变整洁了；对访客而言，吸引他们的是那份未被过度修饰的烟火气。两者需求的平衡，正是微改造能否持续的关键。" },
      { type: "list", items: ["保留街巷肌理与建筑外立面", "更新管线、铺装与公共设施", "在小体量、可逆的前提下改造"] },
      { type: "quote", text: "改造的目标不是让老街变新，而是让它继续好好生活。" },
    ],
  },
  {
    id: 10,
    title: "剧组拍摄地意外走红：取景小巷成为新的打卡点",
    categorySlug: "entertainment",
    excerpt: "随着剧集热播，拍摄取景的一处老街巷被更多观众注意到，周边小店生意也随之变好。",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20old%20cinema%20style%20street%20corner%20with%20warm%20afternoon%20sunlight%20and%20small%20shops%2C%20minimal%20clean%20composition%2C%20editorial%20photography%2C%20cream%20and%20amber%20palette%2C%20high%20detail&width=800&height=600&seq=kl-art-10&orientation=landscape",
    author: "看料编辑部",
    date: "2026-09-03",
    views: 28930,
    hot: false,
    tags: ["剧组路透", "打卡地", "取景地"],
    content: [
      { type: "p", text: "一部热播剧的取景地最近被观众“对上了号”。有细心的观众发现，剧中反复出现的街角画面，就来自城中的一处老街巷，相关照片随即在社交平台传播开来。" },
      { type: "h2", text: "取景地走红带来的连锁反应" },
      { type: "p", text: "周末时段，这条原本安静的巷子出现了明显的拍照人流。周边几家小店表示，客流量比平时增加了不少，也希望人流增加的同时不打扰周边居民。" },
      { type: "h2", text: "理性打卡的建议" },
      { type: "p", text: "有本地居民提醒，巷子本身较窄，且仍有居民日常出行。参观时注意保持安静、不堵塞通道，才是对取景地最好的维护。" },
      { type: "list", items: ["取景地因剧集热播被关注", "周边小店客流随之上升", "参观时应避免影响居民生活"] },
    ],
  },
  {
    id: 11,
    title: "露营装备清单走红：轻量化户外消费持续升温",
    categorySlug: "lifestyle",
    excerpt: "一份强调实用与轻量的露营清单在社交平台被广泛收藏，带动相关品类讨论度上升。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20camping%20gear%20flat%20lay%20with%20lantern%2C%20folded%20blanket%20and%20enamel%20mug%20on%20cream%20background%2C%20soft%20natural%20light%2C%20editorial%20still%20life%2C%20high%20detail%20minimal%20composition&width=800&height=600&seq=kl-art-11&orientation=landscape",
    author: "看料编辑部",
    date: "2026-09-02",
    views: 16420,
    hot: false,
    tags: ["露营", "户外装备", "消费趋势"],
    content: [
      { type: "p", text: "进入秋季，露营再次成为周末出行的热门选择。近期一份强调“轻量化”的装备清单在社交平台被大量收藏，也带动了相关品类的讨论热度。" },
      { type: "h2", text: "清单为什么强调轻量化" },
      { type: "p", text: "不少新手在第一次露营时容易带过多装备，结果搬运成为最大负担。轻量化清单的思路是：优先保证休息与饮食两件事，其余按需补充。" },
      { type: "list", items: ["基础：帐篷、地垫与睡袋", "饮食：便携炉具与保温杯", "照明：营地灯与头灯"] },
      { type: "h3", text: "理性消费的提醒" },
      { type: "p", text: "装备并非越多越好。根据实际出行频率和场地条件选择，才能避免买回来闲置的情况。" },
    ],
  },
  {
    id: 12,
    title: "秋季展览打卡指南：这几处艺术空间人气正旺",
    categorySlug: "fashion",
    excerpt: "多个秋季主题展览陆续开放，凭借空间设计和展陈方式吸引了不少观众前往。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20warm%20art%20gallery%20interior%20with%20cream%20walls%20and%20soft%20spotlights%2C%20abstract%20warm%20toned%20artwork%20on%20wall%2C%20editorial%20photography%2C%20clean%20composition%2C%20high%20detail&width=800&height=600&seq=kl-art-12&orientation=landscape",
    author: "看料编辑部",
    date: "2026-09-01",
    views: 14380,
    hot: false,
    tags: ["展览", "艺术空间", "打卡指南"],
    content: [
      { type: "p", text: "入秋之后，多个主题展览集中开放。与过去以作品数量取胜不同，现在的展览更注重空间叙事，观众的参观动线被安排得更有节奏。" },
      { type: "h2", text: "看展前可以先做的功课" },
      { type: "p", text: "建议提前了解展览的核心主题与作品背景，再决定参观顺序。这样在有限的时间里，更容易抓住展览想表达的线索。" },
      { type: "list", items: ["提前了解展览主题与结构", "选择人少的时段前往", "关注展陈空间本身的设计"] },
      { type: "h2", text: "拍照与观展的平衡" },
      { type: "p", text: "展览空间的视觉设计往往很适合拍照，但也建议留出安静的观展时间。毕竟打动人的，通常还是作品本身。" },
      { type: "quote", text: "看展最好的状态，是走的时候带走了一个新的问题。" },
    ],
  },
];

export const faqs = [
  {
    q: "看料91 的内容主要是什么？",
    a: "看料91 聚合热门爆料、现场记录与话题内容，覆盖娱乐、影视、社会、生活、科技与潮流等方向，以整理和阅读为主，页面内持续更新。",
  },
  {
    q: "点开后需要怎么做才能看到完整内容？",
    a: "进入首页后，可以直接点击任意卡片进入浏览，也可以在分类页按主题翻看。内容详情页提供完整正文与相关推荐，不需要额外跳转。",
  },
  {
    q: "内容多久更新一次？",
    a: "我们会在每日 09:00 至 23:00 之间持续更新，热门话题与新增现场记录会优先展示在首页的热料榜中。",
  },
  {
    q: "可以按主题筛选内容吗？",
    a: "可以。分类页支持按主题查看，并且提供最新、最热两种排序方式，方便你快速找到感兴趣的内容。",
  },
  {
    q: "如何反馈问题或提供线索？",
    a: "可以通过联系页面留言，我们会认真阅读每一条反馈。涉及内容纠错的信息，也会优先处理。",
  },
];